import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, ListOrdered, Settings as SettingsIcon } from 'lucide-react';

const tabs = [
  { label: 'Dashboard', path: '/admin/payments', icon: LayoutDashboard, testid: 'payments-tab-dashboard' },
  { label: 'Transactions', path: '/admin/payments/transactions', icon: ListOrdered, testid: 'payments-tab-transactions' },
  { label: 'Settings', path: '/admin/payments/settings', icon: SettingsIcon, testid: 'payments-tab-settings' },
];

const PaymentsTabs = () => {
  const location = useLocation();
  return (
    <div className="flex items-center gap-1 mb-6 border-b border-slate-700/50">
      {tabs.map((t) => {
        const active = location.pathname === t.path;
        const Icon = t.icon;
        return (
          <Link
            key={t.path}
            to={t.path}
            data-testid={t.testid}
            className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
              active
                ? 'border-amber-500 text-amber-400'
                : 'border-transparent text-slate-400 hover:text-white'
            }`}
          >
            <Icon className="w-4 h-4" />
            {t.label}
          </Link>
        );
      })}
    </div>
  );
};

export default PaymentsTabs;
